
import { upDictType, addDictType } from "@/api/api-basic";
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component
export default class SystemConfigUserAdd extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private typeFlagList!: objAny;
  private modalShow = false;
  private loading = true;

  private FormData: objAny = {};
  private modalTitle = i18n.t("dictionary.add");

  private ruleInline: objAny = {
    typeName: [
      {
        required: true,
        validator: regular.name,
        name: i18n.t("dictionary.typeName"),
        max: 15,
        trigger: "blur"
      }
    ],
    // typePkId: [
    //   {
    //     required: true,
    //     validator: regular.int,
    //     name: "类型编号",
    //     trigger: "blur"
    //   }
    // ],
    typeFlag: [
      {
        required: true,
        message: i18n.t("dictionary.typeFlagPl"),
        trigger: "change"
        // type: "number"
      }
    ]
  };
  private formItem: objAny = {
    typePkId: "",
    typeName: "",
    typeFlag: "0",
    remark: ""
  };
  // private typeFlagList: objAny = {
  //   "0": "只读",
  //   "1": "编辑",
  //   "2": "增删改"
  // };
  private isAdd = false;

  public open(item?: objAny) {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }

    this.modalShow = true;

    if (!item) {
      this.formItem.typePkId = "";
      this.formItem.typeName = "";
      this.formItem.typeFlag = "0";
      this.formItem.remark = "";
      this.modalTitle = i18n.t("dictionary.add");
      this.isAdd = true;
    } else {
      this.formItem.typePkId = item.typePkId;
      this.formItem.typeName = item.typeName;
      this.formItem.typeFlag = item.typeFlag + "";
      this.formItem.remark = item.remark;

      this.modalTitle = i18n.t("dictionary.updata");
      this.isAdd = false;
    }
  }
  public handleSubmit(): void {
    this.loading = true;

    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async submitData(): Promise<void> {
    this.formItem.typeFlag = parseInt(this.formItem.typeFlag);
    let ret: objAny;
    if (this.isAdd) {
      ret = await addDictType(this.formItem);
    } else {
      ret = await upDictType(this.formItem);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
